import { render } from "./MyMFGCode.vue?vue&type=template&id=57a50b44&scoped=true"
import script from "./MyMFGCode.vue?vue&type=script&lang=js"
export * from "./MyMFGCode.vue?vue&type=script&lang=js"

import "./MyMFGCode.vue?vue&type=style&index=0&id=57a50b44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57a50b44"]])

export default __exports__